import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import httpClient from 'superagent';
import queryString from 'querystring';
import { superagentToObservable } from '@bibliocommons/utils-http';
import { MOVIE_DB_API_URL, MOVIE_DB_API_KEY } from 'app/constants/MoviesConstants';
import camelCaseRecursive from 'camelcase-keys-recursive';

function movieDBRequest(method, path, query = {}) {
  const queryStr = queryString.stringify({ ...query, api_key: MOVIE_DB_API_KEY });
  const req = httpClient[method](`${MOVIE_DB_API_URL}${path}?${queryStr}`);

  return superagentToObservable(req).map(res => {
    res.body = camelCaseRecursive(res.body);
    return res;
  });
}

function searchMovies(title, page = 1) {
  // https://developers.themoviedb.org/3/search/search-movies
  return movieDBRequest('get', '/search/movie', {
    language: 'en-US',
    include_adult: false,
    query: title,
    page
  });
}

function getMovieById(movieId) {
  // https://developers.themoviedb.org/3/movies/get-movie-details
  return movieDBRequest('get', `/movie/${movieId}`, {
    language: 'en-US',
    append_to_response: 'videos,credits'
  });
}

function getMovieByTitle(title) {
  return searchMovies(title).pipe(
    mergeMap(res => {
      if (res.body.results && res.body.results.length) {
        return getMovieById(res.body.results[0].id);
      }

      return of({});
    })
  );
}

export default {
  searchMovies,
  getMovieById,
  getMovieByTitle
};
